// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandItemContent_container__22t-N","topContainer":"BrandItemContent_topContainer__J9Emh"};